/**
 * A tab opened before a deploy still runs the previous build, and the first page it opens afterwards asks for that build's
 * files, which the new release does not have: the page never starts. When a page file fails to load (Vite's
 * `vite:preloadError`), reload once onto the current build instead. At most once a minute, so a real outage cannot loop.
 */
const KEY = 'rithmo_stale_build_reload_at'
const WINDOW_MS = 60_000

export function reloadOnStaleBuild(win = window, now = () => Date.now()) {
  win.addEventListener('vite:preloadError', (event) => {
    let last = 0
    try { last = Number(win.sessionStorage.getItem(KEY)) || 0 } catch { return }
    if (now() - last < WINDOW_MS) return
    try { win.sessionStorage.setItem(KEY, String(now())) } catch { return }
    event.preventDefault()
    win.location.reload()
  })
}
